export enum SettingStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum SettingTypeEnum {
  STRING = "string",
  NUMBER = "number",
  BOOLEAN = "boolean",
  JSON = "json",
  ARRAY = "array",
}

export enum SettingApplicationEnum {
  PLATFORM = "platform",
  MOBILE = "mobile",
  BACKOFFICE = "backoffice",
}
